import { Routes } from '@angular/router';

import { isPartialMovieLoadedResolver, MoviePageResolver } from '@usheru-hff/sdk/movie';

const brandedPageData = {
  'branded-movie': true,
  noGlobalStyling: true
};

export const NEW_MOVIE_DETAILS_ROUTES: Routes = [
  // Standard route
  {
    path: ':slug',
    // The guard will fetch data or reuse from SSR,
    // and possibly decide to redirect if needed
    resolve: { movie: MoviePageResolver, isPartialMovieLoaded: isPartialMovieLoadedResolver },
    loadComponent: () => import('./movie-detail-page/movie-detail-page.component').then(m => m.MovieDetailPageComponent)
  },

  // If your "film-info" path is only valid for "branded" movies,
  // the guard can redirect if not branded
  {
    path: ':slug/film-info',
    resolve: { movie: MoviePageResolver, isPartialMovieLoaded: isPartialMovieLoadedResolver },

    data: brandedPageData,
    loadComponent: () =>
      import('@usheru-hff/movie-detail/feature-brand-movie-conversion-vs-awareness').then(
        m => m.FeatureMovieAwarenessPageComponent
      )
  },

  /* type: 'movie' */
  {
    path: ':slug/book-now',
    resolve: { movie: MoviePageResolver, isPartialMovieLoaded: isPartialMovieLoadedResolver },

    data: brandedPageData,
    loadComponent: () =>
      import('@usheru-hff/movie-detail/feature-brand-movie-conversion-vs-awareness').then(
        m => m.FeatureMovieConversionPageComponent
      )
  },

  {
    path: ':slug/watch-now',
    resolve: { movie: MoviePageResolver, isPartialMovieLoaded: isPartialMovieLoadedResolver },
    data: brandedPageData,
    loadComponent: () =>
      import('@usheru-hff/movie-detail/feature-brand-movie-conversion-vs-awareness').then(
        m => m.FeatureMovieConversionPageComponent
      )
  },

  {
    path: ':slug/press-kit',
    resolve: { movie: MoviePageResolver, isPartialMovieLoaded: isPartialMovieLoadedResolver },
    loadChildren: () => import('@usheru-hff/access-locker/assets-locker').then(m => m.AssetsLockerPageModule)
  },

  // If needed, also handle :slug/:param path
  {
    path: ':slug/:param',
    resolve: { movie: MoviePageResolver, isPartialMovieLoaded: isPartialMovieLoadedResolver },
    loadComponent: () => import('./movie-detail-page/movie-detail-page.component').then(m => m.MovieDetailPageComponent)
  }
];
